import { FillUp } from "@fairfleet/geotab";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_FILL_UP } from "@/constants/resultsLimits";
import { usePerDeviceQueries } from "@/hooks/usePerDeviceQueries";

export const FILL_UPS_QUERY_KEY = "fillUps";

/**
 * Geotab's detected fill-ups (`FillUp`, MyGeotab's "Erkannte Tankvorgänge": litres derived from
 * the tank level) per device for a period, one query per device.
 */
export function useFillUpsForDevices(
  deviceIds: string[],
  fromDate: Date,
  toDate: Date,
  enabled = true,
) {
  const { geotabClient } = useGeotabClient();

  return usePerDeviceQueries<FillUp>({
    queryKey: FILL_UPS_QUERY_KEY,
    deviceIds,
    fromDate,
    toDate,
    enabled,
    fetchRecords: (deviceId, signal) =>
      geotabClient.get(
        "FillUp",
        { deviceSearch: { id: deviceId }, fromDate, toDate },
        RESULTS_LIMIT_FILL_UP,
        signal,
      ),
  });
}
